<template>
  <v-container pa-0>
    <div class="v-label mb-2">{{ label }}</div>
    <div class="signature-wrapper">
      <img v-if="disabled" :src="question.value" />
      <signature-pad
        :key="currentTab"
        v-else
        v-model="question.value"
        :rules="[!required || rules.required('signature')]"
      />
    </div>
  </v-container>
</template>

<script>
import QuestionMixin from "./QuestionMixin";
import SignaturePad from "@/components/SignaturePad";
import * as rules from "@/services/rules";

export default {
  name: "SignatureQuestion",
  mixins: [QuestionMixin],
  data: () => ({
    rules
  }),
  components: {
    SignaturePad
  },
  computed: {
    currentTab() {
      return this.$store.state.pageState.activeTab;
    }
  }
};
</script>

<style lang="sass" scoped>
.signature-wrapper
  height: 150px
  background-color: $light-grey
  // this is useful when parent div width is smaller than image width, in which case the image will shrink
  img
    max-width: 100%
</style>
